import React, { Suspense } from 'react';
import { Routes as ReactRoutes, Route, BrowserRouter, useLocation } from 'react-router-dom';

import { useScrollTopOnChange } from '../../hooks/useScrollTopOnChange';
import { fullPageLoadingIndicator } from '../LoadingIndicator';
import FormPage from '../FormPage';
import ErrorPage from '../ErrorPage';
import NotFoundPage from '../NotFoundPage';
import SuccessPage from '../SuccessPage';


const Wrapper = ({children}) => {
  const { pathname } = useLocation();
  useScrollTopOnChange(pathname);

  return children
} 

const Routes = () => {
    return (
        <Suspense fallback={fullPageLoadingIndicator}>
            <BrowserRouter>
                <Wrapper>
                    <ReactRoutes>
                        <Route exact path="/form/:tokenId" element={<FormPage />} />
                        <Route exact path="/error" element={<ErrorPage />} />
                        <Route exact path="/success" element={<SuccessPage />} />
                        <Route path='*' element={<NotFoundPage />} />
                    </ReactRoutes>
                </Wrapper>
            </BrowserRouter>
        </Suspense>
    );
};

export default Routes;
const availableRoutes = [];
export { availableRoutes };